import React, { FunctionComponent, Fragment, useState, useEffect } from 'react';
import { Field } from 'react-final-form';
import { RadioButtonField, RadioButtonGroup } from 'mdlkit';
import { StyledText } from './InsuranceForm';
import getAffiliationEligibilityDetailsAsync from '../../../api/affiliations/getAffiliationEligibilityDetailsAsync';

interface AllowDepRegProps {
  affiliationId?: string;
}

const AllowDepReg: FunctionComponent<AllowDepRegProps> = ({
  affiliationId,
}: AllowDepRegProps) => {
  const [message, setMessage] = useState<string>('');
  const [isYesOption, setIsYesOption] = useState<boolean>(false);

  useEffect(() => {
    getAffiliationEligibilityDetailsAsync(Number(affiliationId)).then(
      ({ affiliationEligibilityDetail }) => {
        if (affiliationEligibilityDetail?.notAllowedFamilyMembersText) {
          setMessage(affiliationEligibilityDetail.notAllowedFamilyMembersText);
          setIsYesOption(true);
        }
      }
    );
  }, []);

  return (
    <Fragment>
      <StyledText>{message}</StyledText>
      <StyledText as="label" htmlFor="isDependent">
        Are you insured as a dependent?
      </StyledText>
      <RadioButtonGroup pt="sm">
        <Field
          id="dependentYes"
          type="radio"
          label="Yes"
          name="isDependent"
          component={RadioButtonField}
          value="true"
          disabled={isYesOption}
        />
        <Field
          id="dependent_no"
          type="radio"
          label="No"
          name="isDependent"
          component={RadioButtonField}
          value="false"
        />
      </RadioButtonGroup>
    </Fragment>
  );
};

export default AllowDepReg;
